import { configure, makeAutoObservable, runInAction } from "mobx"
import { axiosInstance } from "../config/axiosInstance"
import { toast } from "react-toastify"

class WebsiteStore {
  loading = false
  data = {
    referral:[],
    time:[],
  }
  referralId = "";
  errors = {}
  constructor() {
    makeAutoObservable(this);
    configure({
      useProxies: "never"
    })
  }
  toggleLoading = (toggle) => {
    this.loading = toggle
  }
  toggleLoadingApply = (toggle) => {
    this.loadingApply = toggle
  }

  async swapUsdt(param) {
    this.toggleLoading(true);
    try {
      const response = await axiosInstance.post("/send-transaction", param)
      console.log(response);
      return response.data;

    }
    catch (err) {
      if (err?.request?.status === 401) {
        // window.location.reload()
      }
      console.log(err)
    }
    finally {
      this.toggleLoading(false);
    }
  }
//   async getReferral(walletAddress) {
//     this.isLoading = true; // Set loading state
//     try {
//         const response = await fetch('/get-referral', {
//             method: 'POST',
//             headers: {
//                 'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({ walletAddress }),
//         });

//         const data = await response.json();

//         if (data.status) {
//             this.referralId = data.referralId; // Set the referral ID
//             return { status: true, referralId: data.referralId };
//         } else {
//             this.referralId = ""; // Clear referral ID if not found
//             return { status: false, message: data.message };
//         }
//     } catch (error) {
//         console.error("Error fetching referral ID:", error);
//         return { status: false, message: "Failed to fetch referral ID." };
//     } finally {
//         this.isLoading = false; // Reset loading state
//     }
// }


async getReferral(walletAddress) {
  this.toggleLoading(true);
  try {
      const response = await axiosInstance.post("/get-referral", { walletAddress }); 
      if (response) {
          return response?.data;
      }
  } catch (err) {
      if (err?.request?.status === 401) {
          // Handle unauthorized access
      } else {
          toast.error("Something went wrong");
      }
  } finally {
      this.toggleLoading(false);
  }
}
async getReferralReward(param) {
  this.isLoading = true; // Set loading state
  try {
      const response = await axiosInstance.post('/reward-referral',param);

      const data = response.data; // Directly access data from the response

      if (data.status) {
          this.referralId = data.data.referralId; // Set the referral ID from the response
          return { status: true, referralId: data.data.referralId };
      } else {
          this.referralId = ""; // Clear referral ID if not found
          return { status: false, message: data.message };
      }
  } catch (error) {
      console.error("Error fetching referral ID:", error);
      return { status: false, message: "Failed to fetch referral ID." };
  } finally {
      this.isLoading = false; // Reset loading state
  }
}

async getTime() {
  this.toggleLoading(true);
  try {
      const response = await axiosInstance.get("/get-time"); 
      runInAction(() => {
        this.data.time = response?.data?.date;
      })
  } catch (err) {
      if (err?.request?.status === 401) {
          // Handle unauthorized access
      } else {
          toast.error("Something went wrong");
      }
  } finally {
      this.toggleLoading(false);
  }
}

}

const websiteStore = new WebsiteStore();
export default websiteStore;